var React = require('react');

function Vettvangur (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Vettvangur.is"),React.createElement("path",{"d":"M47.1873 36.8108L51.2975 43.8379L76.9999 0H68.7795L47.1873 36.8108Z","key":1}),React.createElement("path",{"d":"M40.7743 25.8378L44.8845 32.9189L64.1751 0H55.8998L40.7743 25.8378Z","key":2}),React.createElement("path",{"d":"M76.8882 52.973H0V60H76.8882V52.973Z","key":3}),React.createElement("path",{"d":"M38.9647 7.02703L25.6477 29.7838L12.3306 7.02703H38.9647ZM51.2953 0H0L25.6477 43.8379L51.2953 0Z","key":4})]);
}

Vettvangur.defaultProps = {"width":"77","height":"60","viewBox":"0 0 77 60"};

module.exports = Vettvangur;

Vettvangur.default = Vettvangur;
